import classNames from 'classnames/bind';
import styles from './QuizDetails.module.css';
import {
  CORRECT_ANSWER,
  INFORMATION,
  NO_ANSWER,
  PAGE,
  QUIZ_INFORMATION,
  QUIZ_INFORMATION_DETAILS,
  SOLUTION_INFORMATION,
  SOLUTION_INFORMATION_DETAILS,
  WRONG_ANSWER,
} from '../../../constants';
import { formulaManager } from '../../../utils/formulaManager';
import { useEffect, useRef } from 'react';
import DrawingView from '../DrawingView';
import { isMobile } from '../../../utils/util';

export default function QuizDetails({ data }: any) {
  const cx = classNames.bind(styles);
  const { contentType, page } = data;

  const inputParentRef = useRef<(HTMLSpanElement | null)[]>([]);

  const informationList = [
    {
      title: QUIZ_INFORMATION,
      keyList: Object.keys(QUIZ_INFORMATION_DETAILS),
      labelList: Object.values(QUIZ_INFORMATION_DETAILS),
    },
    {
      title: SOLUTION_INFORMATION,
      keyList: Object.keys(SOLUTION_INFORMATION_DETAILS),
      labelList: Object.values(SOLUTION_INFORMATION_DETAILS),
    },
  ];

  const convertLatex = (value: string, i: number) => {
    if (inputParentRef.current.length) {
      formulaManager.setFormulaText(inputParentRef.current[i], value);
    }
  };

  useEffect(() => {
    inputParentRef.current.forEach((cell, i) => {
      if (cell?.dataset.latex) {
        convertLatex(cell?.dataset.latex, i);
      }
    });
  }, [inputParentRef.current]);

  return (
    <>
      {contentType === 9 ? (
        <>
          <div key={'drawing_panel'} className={cx('panel', 'drawing')}>
            <div className={cx('panel_title')}>
              <span>{INFORMATION}</span>
            </div>

            <div className={cx('panel_inner')}>
              <div key={'drawing_panel_row_page'} className={cx('panel_row')}>
                <span className={cx('sub')}>{PAGE}</span>
                <span className={cx('detail')}>
                  <input
                    type="text"
                    className={cx('input_t', 'w100')}
                    readOnly
                    value={page}
                  />
                </span>
              </div>
            </div>
          </div>
          <DrawingView data={data} />
        </>
      ) : (
        informationList.map(({ title, keyList, labelList }) => (
          <div key={title} className={cx('panel')}>
            <div className={cx('panel_title')}>
              <span>{title}</span>
            </div>
            <div className={cx('panel_inner')}>
              {keyList.map((key, i) => {
                const value = data[key];
                const hasLatex =
                  (key === 'answer' || key === 'userAnswer') && data.formula;

                return (
                  <div key={key} className={cx('panel_row')}>
                    <span className={cx('sub')}>{labelList[i]}</span>
                    <span
                      className={cx('detail')}
                      ref={(el) => (inputParentRef.current[i] = el)}
                      {...(hasLatex && {
                        'data-latex': data[key].replaceAll('/', ','),
                      })}
                    >
                      {!!hasLatex ||
                        ([
                          'answer',
                          ...(isMobile ? [] : ['indexContent', 'topic']),
                          'userAnswer',
                        ].includes(key) ? (
                          <textarea
                            rows={key === 'userAnswer' && !isMobile ? 5 : 3}
                            readOnly
                            value={
                              key === 'answer' || key === 'userAnswer'
                                ? value?.replaceAll('/', '\n')
                                : value
                            }
                          ></textarea>
                        ) : (
                          <input
                            type="text"
                            className={cx('input_t', 'w100', [key], {
                              correct: value === 'O',
                              incorrect: value === 'X',
                              none: value === NO_ANSWER,
                            })}
                            readOnly
                            value={
                              value === 'O'
                                ? CORRECT_ANSWER
                                : value === 'X'
                                ? WRONG_ANSWER
                                : value
                            }
                          />
                        ))}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        ))
      )}
    </>
  );
}
